module.exports = __webpack_public_path__ + "img/num3.8280d717.png";